import { SxProps, Theme } from '@mui/material';

export const sectionTitleSx: SxProps<Theme> = {
  fontFamily: 'Inter, Arial, sans-serif',
  fontStyle: 'normal',
  fontWeight: 600,
  fontSize: '14px',
  lineHeight: '21px',
  letterSpacing: '-0.15px',
  color: '#111827'
};

export const sectionSublineSx: SxProps<Theme> = {
  fontFamily: 'Inter, Arial, sans-serif',
  fontStyle: 'normal',
  fontWeight: 400,
  fontSize: '12px',
  lineHeight: '18px',
  letterSpacing: '0px',
  color: '#9CA3AF'
};
